import createSelector from 'selectorator';
import * as _ from 'lodash';
import type { PolicyStore } from './store';
import type { ReduxStore } from '../store';

const getPolicies = createSelector<ReduxStore, PolicyStore['policies']>(['policies.policies'], policies => policies);

const policySelectors = {
  getPolicies,
  getPolicyList: createSelector([getPolicies], _.values),
  getStatus: createSelector([`policies.status`], (status) => status),
  getCurrentPolicy: (state: ReduxStore, props: { params: { policyId: number } }) =>
    state.policies.policies[props.params.policyId],
  getExceptions: createSelector(['policies.exceptions'], (exceptions) => exceptions),
};

export default policySelectors;
